
import { type } from '../../../shared/utility/utilityHelpers';
import { Action } from '@ngrx/store';

export const ActionTypes = {
  DO_SECTION_LIST: type('[SECTION] Do SECTION List'),
  DO_SECTION_LIST_SUCCESS: type('[SECTION] Do SECTION Success'),
  DO_SECTION_LIST_FAIL: type('[SECTION] Do SECTION Fail'),

  DO_SECTION_LIST_COUNT: type('[SECTION] Do SECTION  List count'),
  DO_SECTION_LIST_SUCCESS_COUNT: type('[SECTION] Do SECTION Success count'),
  DO_SECTION_LIST_FAIL_COUNT: type('[SECTION] Do SECTION Fail count'),

  DO_ADD_SECTION_ACTION: type('[SECTION] Do SECTION Add '),
  DO_ADD_SECTION_SUCCESS: type('[SECTION] Do SECTION Add  Success'),
  DO_ADD_SECTION_FAIL: type('[SECTION] Do SECTION Add  Fail'),

  DO_UPDATE_SECTION_ACTION: type('[SECTION] Do SECTION Update '),
  DO_UPDATE_SECTION_SUCCESS: type('[SECTION] Do SECTION Update  Success'),
  DO_UPDATE_SECTION_FAIL: type('[SECTION] Do SECTION Update  Fail'),

  DO_DELETE_SECTION_ACTION: type('[SECTION] Do SECTION Delete '),
  DO_DELETE_SECTION_SUCCESS: type('[SECTION] Do SECTION Delete  Success'),
  DO_DELETE_SECTION_FAIL: type('[SECTION] Do SECTION Delete  Fail'),

  GET_SECTION_DETAILS: type('[SECTION] SECTION Details '),
  GET_SECTION_DETAILS_SUCCESS: type('[SECTION] SECTION Details  Success'),
  GET_SECTION_DETAILS_FAIL: type('[SECTION] SECTION Details Fail'),

  CLEAR: type('[SECTION] Clear'),


};

// Section LIST

export class DoSectionListAction implements Action {
  type = ActionTypes.DO_SECTION_LIST;

  constructor() {}
}

export class DoSectionListSuccessAction implements Action {
  type = ActionTypes.DO_SECTION_LIST_SUCCESS;

  constructor(public payload: any) {}
}

export class DoSectionListFailAction implements Action {
  type = ActionTypes.DO_SECTION_LIST_FAIL;

  constructor(public payload: any = null) {}
}

// SECTION COUNT LIST

export class DoSectionListCountAction implements Action {
  type = ActionTypes.DO_SECTION_LIST_COUNT;

  constructor() {}
}

export class DoSectionListCountSuccessAction implements Action {
  type = ActionTypes.DO_SECTION_LIST_SUCCESS_COUNT;

  constructor(public payload: any) {}
}

export class DoSectionListCountFailAction implements Action {
  type = ActionTypes.DO_SECTION_LIST_FAIL_COUNT;

  constructor(public payload: any = null) {}
}


// Add SECTION ACTION

export class DoSectionAddAction implements Action {
  type = ActionTypes.DO_ADD_SECTION_ACTION;

  constructor(public payload: any) {}
}

export class DoSectionAddSuccessAction implements Action {
  type = ActionTypes.DO_ADD_SECTION_SUCCESS;

  constructor(public payload: any) {}
}

export class DoSectionAddFailAction implements Action {
  type = ActionTypes.DO_ADD_SECTION_FAIL;

  constructor(public payload: any = null) {}
}

// # UPDATE SECTION ACTION

export class DoSectionUpdateAction implements Action {
  type = ActionTypes.DO_UPDATE_SECTION_ACTION;

  constructor(public payload: any) {}
}

export class DoSectionUpdateSuccessAction implements Action {
  type = ActionTypes.DO_UPDATE_SECTION_SUCCESS;

  constructor(public payload: any) {}
}

export class DoSectionUpdateFailAction implements Action {
  type = ActionTypes.DO_UPDATE_SECTION_FAIL;

  constructor(public payload: any = null) {}
}

// #  DELETE SECTION ACTION

export class DoSectionDeleteAction implements Action {
  type = ActionTypes.DO_DELETE_SECTION_ACTION;

  constructor(public payload: any) {}
}

export class DoSectionDeleteSuccessAction implements Action {
  type = ActionTypes.DO_DELETE_SECTION_SUCCESS;

  constructor(public payload: any) {}
}

export class DoSetionDeleteFailAction implements Action {
  type = ActionTypes.DO_DELETE_SECTION_FAIL;

  constructor(public payload: any = null) {}
}

// SECTION DETAILS

export class GetSectionDetailsAction implements Action {
  type = ActionTypes.GET_SECTION_DETAILS;
  constructor(public payload: any) {}
}

export class GetSectionDetailsSuccessAction implements Action {
  type = ActionTypes.GET_SECTION_DETAILS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetSectionDetailsFailAction implements Action {
  type = ActionTypes.GET_SECTION_DETAILS_FAIL;
  constructor(public payload: any = null) {}
}

export class ClearAction implements Action {
  type = ActionTypes.CLEAR;
  constructor(public payload: any = null) {}
}









